module.exports = __webpack_public_path__ + "static/img/1.458efce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/sp/1.png
// module id = 2Ge5
// module chunks = 0